import { ManageAreaApiRepository } from "@/app/infrastructures/repositories/api/ManageAreaApiRepository";
import {
  ListManageAreaApiRequest,
  ListAvailableCourierApiRequest,
  ListGeoAddressApiRequest,
  TransferAreaApiRequest,
  AvailableGeoAddressApiRequest,
  CreateAreaApiRequest
} from "@/data/payload/api/ManageAreaApiRequest";
import {
  ManageAreaData,
  ResponseSummaryGeoAddressData,
  AvailableCourierList,
  ResponseTransferAreaData,
  DetailPartnerAreaDedicated,
  UpdatePartnerAreaDedicated
} from "@/domain/entities/ManageArea";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { injectable } from "tsyringe";
import { UpdatePartnerAreaRequestInterface } from '@/data/payload/contracts/ManageAreaRequest';

@injectable()
export class ManageAreaPresenter {
  private repository: ManageAreaApiRepository;

  constructor(repository: ManageAreaApiRepository) {
    this.repository = repository;
  }

  public getList(params: ListManageAreaApiRequest): Promise<ManageAreaData> {
    return this.repository.getList(params);
  }

  public getSummaryGeoAddress(): Promise<ResponseSummaryGeoAddressData> {
    return this.repository.getSummaryGeoAddress();
  }

  public getGeoAddress(
    params: ListGeoAddressApiRequest
  ): Promise<ResponsePayloadV2> {
    return this.repository.getGeoAddress(params);
  }

  public getAvailableCourier(
    params: ListAvailableCourierApiRequest
  ): Promise<AvailableCourierList> {
    return this.repository.getAvailableCourier(params);
  }

  public getTransferArea(uid: string): Promise<ResponseTransferAreaData> {
    return this.repository.getTransferArea(uid);
  }

  public postTransferArea(payload: TransferAreaApiRequest) {
    return this.repository.postTransferArea(payload);
  }
  
  public delete(uid: string): Promise<any> {
    return this.repository.delete(uid);
  }

  public getAvailableGeoAddress(params: AvailableGeoAddressApiRequest) {
    return this.repository.getAvailableGeoAddress(params);
  }

  public createArea(payload: CreateAreaApiRequest) {
    return this.repository.createArea(payload);
  }

  public getDetail(uid: string): Promise<DetailPartnerAreaDedicated> {
    return this.repository.getDetail(uid);
  }

  public update(
    uid: string,
    payload: UpdatePartnerAreaRequestInterface
  ): Promise<UpdatePartnerAreaDedicated> {
    return this.repository.update(uid, payload);
  }
}
